export const SEARCH_ELEMENT_REQUEST = 'SEARCH_ELEMENT_REQUEST';
export const SEARCH_ELEMENT_SUCCESS = 'SEARCH_ELEMENT_SUCCESS';
export const SEARCH_ELEMENT_FAILURE = 'SEARCH_ELEMENT_FAILURE';
